@if (movie()) {
  @if (headerScrollProgressEnabled()) {
    <div class="movie-site_top-menu_scroll-progress" aria-hidden="true">
      <span #headerScrollProgressFill data-movie-site-header-progress-fill></span>
    </div>
  }

  @if (!logosHidden()) {
    <div class="movie-site_top-menu_logos">
      <div class="movie-site_top-menu_logos_small">
        @for (image of images(); track image) {
          <movie-site-logo-image
            [image]="image"
            [contrast]="topMenuSmallContrast()"
            [movie]="movie()"
            [height]="getCustomChannelLogoHeight(image, 'small')"
          />
        }
      </div>
      <div class="movie-site_top-menu_logos_large">
        @for (image of images(); track image) {
          <movie-site-logo-image
            [image]="image"
            [contrast]="topMenuLargeContrast()"
            [movie]="movie()"
            [height]="getCustomChannelLogoHeight(image, 'large')"
          />
        }
      </div>
    </div>
  }

  <div class="movie-site_top-menu_controls">
    <movie-site-side-menu
      linkClass="top-menu_link"
      styleClass="movie-site_top-menu_sidemenu"
      [appendTo]="appendSidemenuTo()"
      closeIconFontSize="var(--sidemenu-icon__fontSize, 28px)"
      closeIconColor="var(--brand-color-support-contrast)"
      [customColorScheme]="customSideMenuColorScheme()"
    >
      <div class="movie-site_top-menu_sidemenu_content">
        <nav class="movie-site_top-menu_sidemenu_nav">
          <ul>
            @for (navAction of configuredNavActions(); track navAction) {
              <li>
                <movie-site-nav-action [navAction]="navAction" (click)="onClinkNavAction()" />
              </li>
            }
          </ul>
        </nav>
        <div
          class="movie-site_top-menu_sidemenu_sharing"
          [class.movie-site_top-menu_sidemenu_sharing--bottom]="logosHidden()"
        >
          <ush-movie-tell-friends [movie]="movie()" />
        </div>
        @if (!logosHidden()) {
          <div class="movie-site_top-menu_sidemenu_logos">
            @for (image of images(); track image) {
              <movie-site-logo-image
                [image]="image"
                [contrast]="sideMenuLogoContrast()"
                [movie]="movie()"
                [logoFilter]="sideMenuLogosFilter()"
                [height]="getCustomChannelLogoHeight(image, 'sidemenu')"
              />
            }
          </div>
        }
      </div>
    </movie-site-side-menu>
  </div>
}
